export const articles = [
  {
    id: 'article-01',
    slug: 'how-to-choose-fresh-vegetables',
    title: '如何挑选新鲜蔬菜？新有菜教你几招实用技巧',
    excerpt: '面对琳琅满目的蔬菜，怎么才能挑到最新鲜的？本文从看、摸、闻三个维度，教你轻松辨别蔬菜新鲜度，让你每次都能买到好菜。',
    content: `<p>在日常买菜的过程中，很多人都遇到过这样的困扰：明明看起来不错的蔬菜，买回家却发现不够新鲜。其实，挑选新鲜蔬菜是有技巧的。今天，新有菜就来教大家几招实用的挑菜方法。</p>
<h2>一、看外观</h2>
<p>新鲜蔬菜的第一个特征就是色泽鲜艳、形态饱满。叶菜类应该叶片挺括、颜色翠绿，没有发黄或枯萎的迹象；根茎类蔬菜表面应该光滑、没有明显的斑点和芽眼；茄果类蔬菜表皮应该富有光泽、手感坚实。</p>
<p>特别要注意的是，如果蔬菜表面有明显的水渍或者过于湿润，可能是商家为了保持卖相而喷水，这样的蔬菜并不一定新鲜。</p>
<h2>二、摸手感</h2>
<p>用手轻轻触摸蔬菜，可以感受其新鲜程度。新鲜蔬菜手感坚实有弹性，不会软塌塌的。比如新鲜的黄瓜摸起来应该是硬挺的，表面有小刺；新鲜的西红柿捏起来有弹性，不会太软也不会太硬。</p>
<p>对于根茎类蔬菜，可以掂一掂重量，同样大小的蔬菜，越重说明水分越充足，越新鲜。</p>
<h2>三、闻气味</h2>
<p>新鲜蔬菜有其特有的清香。如果闻到异味、酸味或者霉味，说明蔬菜已经开始变质，不宜购买。特别是叶菜类，如果有明显的烂叶味道，即使只是部分叶片有问题，也建议不要购买。</p>
<h2>四、看季节</h2>
<p>购买当季蔬菜不仅价格实惠，新鲜度和口感也更好。反季节蔬菜虽然也能买到，但往往需要长途运输或大棚种植，新鲜度和营养价值都会有所折扣。新有菜始终坚持应季供应，确保每一份蔬菜都是当季最新鲜的。</p>
<h2>五、选渠道</h2>
<p>选择可靠的购买渠道同样重要。新有菜与全国优质蔬菜产地建立直供合作，从采摘到配送全程冷链，确保蔬菜以最佳状态送达您的餐桌。相比传统菜市场层层转手的模式，直供模式能最大程度保留蔬菜的新鲜度。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Fresh%20vegetables%20selection%20guide%20with%20various%20colorful%20vegetables%20displayed%20on%20a%20wooden%20table%2C%20bright%20natural%20lighting%2C%20clean%20minimal%20food%20photography%20style%2C%20professional%20composition&width=1200&height=630&seq=article-01-cover&orientation=landscape',
    category: '选菜指南',
    author: '新有菜小助手',
    publishDate: '2026-08-08',
    readTime: '5分钟',
    tags: ['挑菜技巧', '蔬菜新鲜度', '生活小窍门'],
  },
  {
    id: 'article-02',
    slug: 'seasonal-vegetables-guide-summer',
    title: '夏季时令蔬菜全攻略：应季而食更健康',
    excerpt: '夏季有哪些时令蔬菜？不同蔬菜有什么营养价值？怎样搭配更健康？新有菜为你整理了一份夏季蔬菜食用指南，让你吃对季节、吃出健康。',
    content: `<p>中医讲究"不时不食"，意思是要吃当季的食物。夏季气候炎热，人体新陈代谢旺盛，选对时令蔬菜不仅能消暑解热，还能补充身体所需的各种营养。</p>
<h2>夏季时令蔬菜推荐</h2>
<p><strong>1. 苦瓜</strong> — 清热解毒的夏季首选。苦瓜含有丰富的维生素C和苦瓜素，具有清热祛暑、明目解毒的功效。可以凉拌、炒蛋或者煲汤。</p>
<p><strong>2. 黄瓜</strong> — 含水量高达96%，是夏季补水的好选择。黄瓜性凉味甘，具有清热利水的作用。生吃、凉拌或者做沙拉都非常适合。</p>
<p><strong>3. 西红柿</strong> — 富含番茄红素和维生素C，夏季食用可以防晒美白。生吃、炒蛋、做汤都是不错的选择。</p>
<p><strong>4. 冬瓜</strong> — 性寒味甘，是夏季消暑的佳品。冬瓜含水量高、热量低，适合煲汤或者清炒。</p>
<p><strong>5. 空心菜</strong> — 夏季的当家绿叶菜，富含钙、铁和维生素，清脆爽口，蒜蓉炒制最为经典。</p>
<p><strong>6. 茄子</strong> — 夏季茄子最为鲜嫩，富含花青素和维生素P，有助于保护心血管。可以红烧、清蒸或者凉拌。</p>
<p><strong>7. 丝瓜</strong> — 口感嫩滑，营养丰富，有"美人水"之称，夏季食用可以清热化痰、凉血解毒。</p>
<h2>夏季饮食注意事项</h2>
<p>夏季饮食应以清淡为主，多吃蔬菜水果，少吃油腻辛辣的食物。同时要注意食品卫生，蔬菜一定要清洗干净，最好现买现吃，避免长时间存放。</p>
<p>新有菜每日为您精选当季最新鲜的蔬菜，从田间直送到您家，让您轻松享受应季而食的健康生活。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Summer%20seasonal%20vegetables%20assortment%20with%20cucumber%20tomato%20bitter%20gourd%20and%20eggplant%20on%20a%20wooden%20table%2C%20bright%20sunny%20natural%20lighting%2C%20fresh%20vibrant%20colors%2C%20clean%20food%20photography&width=1200&height=630&seq=article-02-cover&orientation=landscape',
    category: '时令推荐',
    author: '新有菜营养师',
    publishDate: '2026-08-05',
    readTime: '6分钟',
    tags: ['时令蔬菜', '夏季饮食', '健康养生'],
  },
  {
    id: 'article-03',
    slug: 'vegetable-storage-tips',
    title: '蔬菜保鲜有妙招：让新鲜多留几天',
    excerpt: '买回家的蔬菜怎么保存才能延长保鲜期？不同蔬菜的储存方法大不相同。掌握这些保鲜技巧，减少浪费，让每一份蔬菜都物尽其用。',
    content: `<p>很多家庭都有一个共同的烦恼：买回家的蔬菜没放几天就蔫了、烂了。其实，不同种类的蔬菜需要不同的储存方法。掌握了正确的保鲜技巧，就能让蔬菜的新鲜度延长好几天。</p>
<h2>叶菜类保鲜方法</h2>
<p>叶菜类是最容易蔫的蔬菜。买回来后，先用厨房纸巾将表面的水分吸干，然后用保鲜袋装好，放入冰箱冷藏室。在保鲜袋里放一张干燥的厨房纸巾，可以吸收多余的水分，防止叶片腐烂。</p>
<p>小贴士：菠菜、生菜等可以用湿布包裹根部，竖着放在冰箱里，这样能保持更长时间的新鲜。</p>
<h2>根茎类保鲜方法</h2>
<p>土豆、红薯等根茎类蔬菜不需要放冰箱，放在阴凉通风处即可。但要注意避免阳光直射，否则容易发芽变绿。胡萝卜、白萝卜可以去掉叶子后放入保鲜袋冷藏。</p>
<h2>茄果类保鲜方法</h2>
<p>西红柿不要放冰箱！低温会破坏西红柿的口感和风味。常温保存即可，蒂头朝下放置。茄子、青椒等可以用保鲜袋装好放冰箱冷藏，但最好在3-5天内食用完毕。</p>
<h2>菌菇类保鲜方法</h2>
<p>菌菇类比较容易变质，买回来后不要清洗，直接用厨房纸巾包裹好放入保鲜袋，然后放冰箱冷藏。食用前再清洗，可以延长保鲜期。</p>
<h2>通用保鲜原则</h2>
<p>1. 蔬菜买回来后尽快处理，去掉黄叶和根部泥土</p>
<p>2. 不同蔬菜分开存放，避免串味和交叉影响</p>
<p>3. 先吃容易变质的蔬菜，耐放的可以后吃</p>
<p>4. 定期检查冰箱里的蔬菜，及时处理变质的</p>
<p>新有菜采用小份量包装，让您每次都能吃到新鲜蔬菜，减少囤积和浪费。当日下单，次日清晨采摘配送，确保蔬菜以最佳新鲜度到达您的手中。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Vegetables%20stored%20neatly%20in%20refrigerator%20drawers%20organized%20by%20type%2C%20bright%20clean%20kitchen%20scene%2C%20fresh%20produce%2C%20professional%20food%20storage%20photography&width=1200&height=630&seq=article-03-cover&orientation=landscape',
    category: '实用技巧',
    author: '新有菜小管家',
    publishDate: '2026-08-01',
    readTime: '5分钟',
    tags: ['保鲜技巧', '蔬菜储存', '生活妙招'],
  },
  {
    id: 'article-04',
    slug: 'organic-vegetables-benefits',
    title: '有机蔬菜到底值不值得买？一文读懂有机真相',
    excerpt: '有机蔬菜价格比普通蔬菜高出不少，它到底好在哪？营养价值真的更高吗？新有菜带你了解有机蔬菜背后的真相。',
    content: `<p>随着人们健康意识的提高，有机蔬菜越来越受到消费者的青睐。但有机蔬菜价格通常是普通蔬菜的2-3倍，它到底值不值得这个价格？今天我们就来聊聊有机蔬菜那些事。</p>
<h2>什么是有机蔬菜？</h2>
<p>有机蔬菜是指在生产过程中不使用化学合成的农药、化肥、生长调节剂等物质，遵循自然规律和生态学原理种植的蔬菜。有机种植强调土壤健康、生物多样性和生态平衡。</p>
<h2>有机蔬菜的优势</h2>
<p><strong>1. 更安全</strong> — 不使用化学农药和化肥，减少了农药残留的风险，尤其适合儿童、孕妇和老人食用。</p>
<p><strong>2. 更美味</strong> — 有机种植的蔬菜生长周期更长，自然成熟，风味物质积累更充分，口感通常更好。</p>
<p><strong>3. 更环保</strong> — 有机农业避免了化学物质对土壤和水源的污染，有利于保护生态环境。</p>
<p><strong>4. 营养价值</strong> — 多项研究表明，有机蔬菜中某些抗氧化物质和微量元素的含量可能略高于常规蔬菜。</p>
<h2>如何辨别真正的有机蔬菜？</h2>
<p>购买有机蔬菜时，注意查看包装上的有机认证标志。中国有机产品认证标志是辨别真伪的重要依据。正规的有机蔬菜都有可追溯的认证编码。</p>
<h2>新有菜的有机承诺</h2>
<p>新有菜与多家通过国家有机认证的蔬菜基地建立合作，从源头把控品质。我们的有机蔬菜可全程追溯，每一批都有检测报告，让您买得放心、吃得安心。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Organic%20vegetable%20farm%20with%20rows%20of%20green%20vegetables%20growing%20in%20rich%20soil%2C%20golden%20sunlight%2C%20peaceful%20countryside%20scene%2C%20sustainable%20agriculture%20photography&width=1200&height=630&seq=article-04-cover&orientation=landscape',
    category: '健康饮食',
    author: '新有菜营养师',
    publishDate: '2026-07-28',
    readTime: '6分钟',
    tags: ['有机蔬菜', '食品安全', '健康饮食'],
  },
  {
    id: 'article-05',
    slug: 'vegetable-cooking-for-kids',
    title: '孩子不爱吃蔬菜？试试这些创意做法',
    excerpt: '很多家长都为孩子不爱吃蔬菜而头疼。其实，只要换个做法，蔬菜也能变成孩子爱吃的"美味"。分享几道孩子超爱的蔬菜创意料理。',
    content: `<p>"我家孩子就是不爱吃蔬菜"——这句话大概是很多家长的心声。其实，孩子不爱吃蔬菜，很多时候不是蔬菜本身的问题，而是做法不够吸引人。今天就来分享几个让孩子爱上蔬菜的小妙招。</p>
<h2>1. 彩虹蔬菜串</h2>
<p>将不同颜色的蔬菜（小番茄、黄瓜块、黄椒块、胡萝卜片等）串在竹签上，配上孩子喜欢的蘸酱（酸奶酱、芝麻酱等），颜色丰富又有趣，孩子很难拒绝。</p>
<h2>2. 蔬菜鸡蛋饼</h2>
<p>将菠菜、胡萝卜等蔬菜切碎，混入蛋液中煎成小饼，搭配番茄酱，外形可爱、口感丰富，是早餐的好选择。</p>
<h2>3. 蔬菜肉丸</h2>
<p>在肉馅中加入细细切碎的香菇、胡萝卜、洋葱等蔬菜，做成肉丸。蔬菜的加入让肉丸更多汁、更健康，孩子吃不出"菜味"。</p>
<h2>4. 花样蔬菜面</h2>
<p>用菠菜汁、胡萝卜汁和面，做出彩色的手工面条。色彩缤纷的面条能激发孩子的好奇心和食欲。</p>
<h2>5. 蔬菜小披萨</h2>
<p>用全麦面包片做底，铺上番茄酱、芝士和各种彩色蔬菜丁，放入烤箱烤至芝士融化。孩子参与制作的过程，更容易接受成品。</p>
<h2>让孩子爱上蔬菜的心理学</h2>
<p>1. 让孩子参与蔬菜的挑选和制作过程</p>
<p>2. 把蔬菜做得好看有趣，色彩丰富</p>
<p>3. 家长以身作则，营造爱吃蔬菜的家庭氛围</p>
<p>4. 不强迫，用鼓励和创意引导</p>
<p>新有菜精选适合孩子食用的嫩叶菜和甜美蔬菜，让每个家庭都能轻松做出孩子爱吃的蔬菜料理。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Colorful%20creative%20vegetable%20dishes%20for%20kids%20arranged%20on%20a%20bright%20table%2C%20fun%20food%20presentation%2C%20rainbow%20vegetable%20skewers%2C%20happy%20family%20food%20photography&width=1200&height=630&seq=article-05-cover&orientation=landscape',
    category: '创意料理',
    author: '新有菜小助手',
    publishDate: '2026-07-22',
    readTime: '5分钟',
    tags: ['儿童饮食', '蔬菜料理', '创意食谱'],
  },
  {
    id: 'article-06',
    slug: 'farm-to-table-journey',
    title: '一颗蔬菜的旅程：从田间到餐桌需要几步？',
    excerpt: '你餐桌上的蔬菜，经历了怎样的旅程才能到达？新有菜带你了解蔬菜从采摘、分拣、包装到配送的全过程，感受每一份新鲜背后的用心。',
    content: `<p>当你打开新有菜的包装，看到鲜嫩欲滴的蔬菜时，你是否好奇过：这些蔬菜是从哪里来的？经历了怎样的旅程？今天，我们一起走进蔬菜的"旅程日记"。</p>
<h2>第一步：产地直采</h2>
<p>新有菜与全国多个优质蔬菜产地建立了直供合作关系。每天凌晨4点，我们的采购团队就已经在合作基地开始选品。根据当天的订单量，精准采摘最新鲜的蔬菜。从采摘到发出，不超过3小时。</p>
<h2>第二步：严格分拣</h2>
<p>采摘后的蔬菜会被送到分拣中心。在这里，专业人员会对蔬菜进行严格筛选：去掉有瑕疵的、不够新鲜的，只保留品质最好的。每一棵蔬菜都要经过外观、新鲜度、规格等多重标准的检验。</p>
<h2>第三步：专业包装</h2>
<p>通过筛选的蔬菜会按照订单进行分装。我们根据蔬菜的特性采用不同的包装方式：叶菜类使用透气保鲜袋，根茎类使用环保纸袋，易损蔬菜有专门的防震包装。所有包装材料均符合食品级标准。</p>
<h2>第四步：冷链配送</h2>
<p>包装好的蔬菜会立即装入冷链运输车，全程保持2-8°C的恒温环境。我们的配送团队会在当天将蔬菜送达您指定的地址。从下单到收货，全程不超过24小时。</p>
<h2>第五步：到达餐桌</h2>
<p>当您收到新有菜的包裹时，打开包装，就能闻到蔬菜特有的清新气息。每一片叶子都饱满挺括，每一颗果实都色泽鲜亮——这就是新鲜该有的样子。</p>
<h2>新有菜的承诺</h2>
<p>我们承诺：所有蔬菜当日采摘、当日配送、新鲜到家。如发现任何品质问题，无条件退换。因为我们深知，每一份蔬菜都承载着一个家庭对健康生活的期待。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Vegetable%20supply%20chain%20journey%20from%20farm%20field%20to%20delivery%20truck%2C%20fresh%20produce%20being%20harvested%20and%20packed%2C%20professional%20agriculture%20logistics%20photography%2C%20clean%20bright%20style&width=1200&height=630&seq=article-06-cover&orientation=landscape',
    category: '品牌故事',
    author: '新有菜编辑组',
    publishDate: '2026-07-18',
    readTime: '5分钟',
    tags: ['供应链', '蔬菜旅程', '从田间到餐桌'],
  },
];